import { render, staticRenderFns } from "./ResultadoDifal.vue?vue&type=template&id=0290918b&scoped=true&"
import script from "./ResultadoDifal.vue?vue&type=script&lang=js&"
export * from "./ResultadoDifal.vue?vue&type=script&lang=js&"
import style0 from "./ResultadoDifal.vue?vue&type=style&index=0&id=0290918b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0290918b",
  null
  
)

export default component.exports